import React, { useEffect, useState } from "react";
import {
  Drawer,
  Form,
  Input,
  InputNumber,
  Button,
  Select,
  Table,
  Space,
  Card,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

const CreateDrink = ({ open, onClose, onSubmit, initialValues, cat }) => {
  const [form] = Form.useForm();

  const [pegs, setPegs] = useState([]);
  const [pegQty, setPegQty] = useState("");
  const [pegPrice, setPegPrice] = useState("");
  const [pegAcPrice, setPegAcPrice] = useState("");
  const [pegEditIndex, setPegEditIndex] = useState(null);

  useEffect(() => {
    if (open) {
      form.resetFields();

      if (initialValues) {
        form.setFieldsValue(initialValues);
        setPegs(initialValues.pegs || []);
      } else {
        resetPeg();
      }
    }
  }, [open, initialValues, form]);

  const resetPeg = () => {
    setPegs([]);
    setPegQty("");
    setPegPrice("");
    setPegAcPrice("");
    setPegEditIndex(null);
  };

  const clearInputs = () => {
    setPegQty("");
    setPegPrice("");
    setPegAcPrice("");
    setPegEditIndex(null);
  };

  const handleFinish = (values) => {
    onSubmit({
      ...values,
      pegs,
    });
  };

  const addPeg = () => {
    if (!pegQty || !pegPrice) return;

    setPegs([
      ...pegs,
      {
        qty: pegQty,
        price: pegPrice,
        ac_price: pegAcPrice || 0,
      },
    ]);

    clearInputs();
  };

  const editPeg = (index) => {
    const peg = pegs[index];

    setPegQty(peg.qty);
    setPegPrice(peg.price);
    setPegAcPrice(peg.ac_price);
    setPegEditIndex(index);
  };

  const updatePeg = () => {
    const updated = [...pegs];

    updated[pegEditIndex] = {
      qty: pegQty,
      price: pegPrice,
      ac_price: pegAcPrice || 0,
    };

    setPegs(updated);
    clearInputs();
  };

  const deletePeg = (index) => {
    const updated = [...pegs];
    updated.splice(index, 1);
    setPegs(updated);
  };

  const pegColumns = [
    {
      title: "S.No",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Qty",
      dataIndex: "qty",
    },
    {
      title: "Price",
      dataIndex: "price",
    },
    {
      title: "AC Price",
      dataIndex: "ac_price",
    },
    {
      title: "Action",
      render: (_, __, index) => (
        <Space>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => editPeg(index)}
          >
            Edit
          </Button>

          <Button
            danger
            type="link"
            icon={<DeleteOutlined />}
            onClick={() => deletePeg(index)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Drawer
      title={initialValues ? "Edit Drink" : "Create Drink"}
      width={820}
      open={open}
      onClose={onClose}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
      >
        <div className="page-card table-card">
          <div className="table-card-header">
            <div>
              <h3>
                {initialValues
                  ? "Update Drink Details"
                  : "Create Drink Details"}
              </h3>

              <p>Fill the details below to save the drink item.</p>
            </div>
          </div>

          <div className="form-grid-2">
            <Form.Item
              label="Drink Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: "Please enter drink name",
                },
              ]}
            >
              <Input placeholder="Enter drink name" />
            </Form.Item>

            <Form.Item
              label="Category"
              name="category_id"
              rules={[
                {
                  required: true,
                  message: "Please select category",
                },
              ]}
            >
              <Select
                placeholder="Select category"
                options={(cat || []).map((item) => ({
                  label: item.name,
                  value: item.id,
                }))}
              />
            </Form.Item>

            <Form.Item label="Volume" name="qty">
              <InputNumber
                className="w-full"
                min={0}
                placeholder="Enter volume"
              />
            </Form.Item>

            <Form.Item label="Unit" name="unit">
              <Select placeholder="Select unit">
                <Select.Option value="ml">ml</Select.Option>
                <Select.Option value="l">Liter</Select.Option>
                <Select.Option value="pcs">Pcs</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item label="Sell Price" name="sell_price">
              <InputNumber
                className="w-full"
                min={0}
                placeholder="Enter sell price"
              />
            </Form.Item>

            <Form.Item label="Original Price" name="margin_price">
              <InputNumber
                className="w-full"
                min={0}
                placeholder="Enter original price"
              />
            </Form.Item>

            <Form.Item label="AC Price" name="ac_price">
              <InputNumber
                className="w-full"
                min={0}
                placeholder="Enter AC price"
              />
            </Form.Item>

            <Form.Item label="CGST" name="cgst">
              <InputNumber
                className="w-full"
                min={0}
                placeholder="Enter CGST"
              />
            </Form.Item>

            <Form.Item label="SGST" name="sgst">
              <InputNumber
                className="w-full"
                min={0}
                placeholder="Enter SGST"
              />
            </Form.Item>
            {/*

            <Form.Item label="Tax" name="tax">
              <InputNumber
                className="w-full"
                min={0}
                placeholder="Enter tax"
              />
            </Form.Item>  */}

            <Form.Item label="Status" name="status">
              <Select placeholder="Select status">
                <Select.Option value="Active">
                  Active
                </Select.Option>
                <Select.Option value="Inactive">
                  Inactive
                </Select.Option>
              </Select>
            </Form.Item>

            <Form.Item label="HSN Code" name="hsn_code">
              <Input placeholder="Enter HSN code" />
            </Form.Item>
          </div>

          <Card
            size="small"
            title="Peg List"
            style={{ marginTop: 16 }}
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4,1fr)",
                gap: "10px",
                marginBottom: 14,
              }}
            >
              <Input
                placeholder="Qty"
                value={pegQty}
                onChange={(e) => setPegQty(e.target.value)}
              />

              <Input
                placeholder="Price"
                value={pegPrice}
                onChange={(e) => setPegPrice(e.target.value)}
              />

              <Input
                placeholder="AC Price"
                value={pegAcPrice}
                onChange={(e) =>
                  setPegAcPrice(e.target.value)
                }
              />

              {pegEditIndex !== null ? (
                <Space>
                  <Button
                    type="primary"
                    onClick={updatePeg}
                  >
                    Update
                  </Button>

                  <Button onClick={clearInputs}>
                    Clear
                  </Button>
                </Space>
              ) : (
                <Button
                  type="primary"
                  onClick={addPeg}
                >
                  Add Peg
                </Button>
              )}
            </div>

            <Table
              rowKey={(row, index) => index}
              columns={pegColumns}
              dataSource={pegs}
              pagination={false}
              size="small"
            />
          </Card>

          <div className="form-actions">
            <Button
              className="secondary-btn"
              onClick={onClose}
            >
              Cancel
            </Button>

            <Button
              type="primary"
              htmlType="submit"
              className="primary-btn"
            >
              {initialValues
                ? "Update Drink"
                : "Save Drink"}
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};

export default CreateDrink;